var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-item-r"},[_c('div',{staticClass:"v-report-list"},[(_vm.subjectType == 'ACTOR')?[_c('ActorData')]:(_vm.subjectType == 'VISITOR')?[_c('VisitorData')]:_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }